
export const changelog = [
    {
        type: "new",
        audience: "customer",
        desc: "Added Custom Recipe Column To Reports.",
        details:
            "A new column has been added to the Cycle Reports and Cycle Report Exports to show the Custom Recipe name used for cycles when applicable.",
        images: [],
    },
];
